
<!-- <h1 mat-dialog-title>{{title}}</h1> -->
<div class="row modal-title-bg text-left" >
  <div class="col float-left ml-4 mt-1">
    <h2 class="text-white ml-2">{{ title }}</h2>
  </div>
  <div class="col float-right mr-5" style="margin-left: 92.5%;margin-top: -40px;">
    <button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="row ">
  <div mat-dialog-content style="margin-left: -16px;margin-top:5px">
    {{message}}
  </div>

</div>
<div class="row" style="float:right;margin:20px;">

  <div >
    <button mat-raised-button class="modal-title-bg" style="margin:0px 10px;"  (click)="yes()">{{'Ok' | translate}}</button>
    @if (buttonCancel) {
      <button mat-raised-button class="modal-title-bg"  (click)="no()">{{'Cancel' | translate}}</button>
    }
    <!-- <input style="margin:0px 10px;" type="button" value="Confirm" [mat-dialog-close]="true"> -->
    <!-- <input type="button" value="Cancel"   [mat-dialog-close]="false"> -->
  </div>
</div>